import {
  ADS_PREFERENCE_TYPES,
  moduleTaskLabelKey,
  type AdsNotificationType,
  type PersonalNotification,
} from './types'

export type NotificationCopy = {
  titleKey: string
  bodyKey: string
  params?: Record<string, unknown>
}

const ADS_TYPE_SET = new Set<string>(ADS_PREFERENCE_TYPES)

/**
 * Resolve dashboard i18n keys for a personal notification row.
 * Ads types get dedicated copy; AI generation keeps processReview/processFailure.
 */
export function personalNotificationCopy(
  item: Pick<PersonalNotification, 'type' | 'payload'>,
): NotificationCopy {
  if (ADS_TYPE_SET.has(item.type)) {
    return {
      titleKey: `notifications.ads.${item.type as AdsNotificationType}.title`,
      bodyKey: `notifications.ads.${item.type as AdsNotificationType}.body`,
    }
  }

  const taskKey = moduleTaskLabelKey(item.payload.module as string | undefined)
  if (item.type === 'generation_ready') {
    return {
      titleKey: 'notifications.processReview.title',
      bodyKey: 'notifications.processReview.body',
      params: { taskKey },
    }
  }

  return {
    titleKey: 'notifications.processFailure.title',
    bodyKey: 'notifications.processFailure.body',
    params: { taskKey },
  }
}
